import { useEffect, useState } from "react";
import { MessageCircle, X, Sparkles } from "lucide-react";

export const ChatLauncher = ({ title, testId, children }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <>
      <div className={`fixed inset-x-3 bottom-20 z-40 max-h-[calc(100vh-7rem)] flex-col rounded-3xl border border-slate-200 bg-white p-3 shadow-2xl sm:inset-x-auto sm:right-6 sm:w-[400px] ${open ? "flex" : "hidden"}`} data-testid={`${testId}-panel`}>
          <div className="mb-2 flex items-center justify-between px-1">
            <span className="flex items-center gap-2 font-bold text-slate-900"><span className="grid h-8 w-8 place-items-center rounded-xl bg-violet-600 text-white"><Sparkles size={16} /></span>{title}</span>
            <button onClick={() => setOpen(false)} className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100" aria-label="Tutup" data-testid={`${testId}-close`}><X size={18} /></button>
          </div>
          {children}
      </div>
      <button onClick={() => setOpen((o) => !o)} aria-label={title} data-testid={`${testId}-button`}
        className="fixed bottom-5 right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-violet-600 text-white shadow-lg shadow-violet-600/30 transition-transform duration-200 hover:scale-105 sm:right-6">
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </>
  );
};
